// A paid event's ticket picker, as arithmetic: how many tickets, what
// they come to, and whether a member code has to be asked for. Pure,
// so the harness runs it in node. The server prices the order again
// from the saved event (EventTickets::lines); nothing here is trusted
// for money, only shown.

/** Quantities as the form holds them, cleaned: whole numbers from 0
 *  to max, for keys the event actually has. */
export function cleanQuantities(types, qty, max = 20) {
    const out = {};
    for (const t of types || []) {
        const n = Math.floor(Number(qty?.[t.key]) || 0);
        out[t.key] = Math.max(0, Math.min(max, n));
    }
    return out;
}

export function ticketCount(types, qty) {
    return Object.values(cleanQuantities(types, qty)).reduce((a, b) => a + b, 0);
}

/** The order's total in the currency's units, to the cent. */
export function ticketTotal(types, qty) {
    const q = cleanQuantities(types, qty);
    let cents = 0;
    for (const t of types || []) cents += Math.round(Number(t.price) * 100) * q[t.key];
    return cents / 100;
}

/** Whether the form must ask for the member code: only when a
 *  members-only ticket is in the order and the event has a code. */
export function needsMemberCode(tickets, qty) {
    if (!tickets?.member_code_required) return false;
    const q = cleanQuantities(tickets.types, qty);
    return (tickets.types || []).some((t) => t.members_only && q[t.key] > 0);
}
